/*
 *
 * UserManagement actions
 *
 */

import {
  GET_USERS_WATCHER,
  GET_USERS_SUCCESS,
  GET_USERS_FAILED,
  DELETE_USER_WATCHER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  SWITCH_USER_WATCHER,
  SWITCH_USER_SUCCESS,
  SWITCH_USER_FAILED,
  UPDATE_INFO_USER,
} from "./constants"

export function updateInfoUserWatcher(payload) {
  return {
    type: UPDATE_INFO_USER,
    payload,
  }
}

export function switchUserWatcher(payload) {
  return {
    type: SWITCH_USER_WATCHER,
    payload,
  }
}

export function switchUserSuccess(payload) {
  return {
    type: SWITCH_USER_SUCCESS,
    payload,
  }
}

export function switchUserFailed(payload) {
  return {
    type: SWITCH_USER_FAILED,
    payload,
  }
}

export function deleteUserWatcher(payload) {
  return {
    type: DELETE_USER_WATCHER,
    payload,
  }
}

export function deleteUserSuccess(payload) {
  return {
    type: DELETE_USER_SUCCESS,
    payload,
  }
}

export function deleteUserFailed(payload) {
  return {
    type: DELETE_USER_FAILED,
    payload,
  }
}

export function getUsersWatcher(payload) {
  return {
    type: GET_USERS_WATCHER,
    payload,
  }
}

export function getUsersSuccess(payload) {
  return {
    type: GET_USERS_SUCCESS,
    payload,
  }
}

export function getUsersFailed(payload) {
  return {
    type: GET_USERS_FAILED,
    payload,
  }
}
